const SR_CONFIGS_LEVEL_UPDATED = (state, data) => {
  state.srConfigsByLevel = data
  state.srConfigsByLevelLoading = false
}

const SR_CONFIGS_LEVEL_LOADING = (state, data) => {
  state.srConfigsByLevelLoading = true
  state.srConfigsByLevelError = false
}

const SR_CONFIGS_LEVEL_ERROR = (state, data) => {
  state.srConfigsByLevelError = true
  state.srConfigsByLevelLoading = false
}

const SUCCESS_RATE_INITIAL_DATE = (state, data) => {
  state.currentMonth = data
}

const SUCCESS_RATE_LOADING = (state) => {
  state.successRatesLoading = true
  state.successRatesError = false
}

const NO_MORE_SUCCESS_RATE = (state) => {
  state.noMoreSuccessRate = true
  state.successRatesLoading = false
}

const RESET_SUCCESS_RATE = (state) => {
  state.successRates = null
  state.currentMonth = null
  state.noMoreSuccessRate = false
}

const SUCCESS_RATE_UPDATED = (state, rates) => {
  if (rates.length > 0) {
    state.successRates = (state.successRates || []).concat(rates).reduce((acc, cur) => [
      ...acc.filter((obj) => obj.from_date !== cur.from_date), cur
    ], [])
  }
  state.successRatesLoading = false
  state.successRatesError = false
}
const SUCCESS_RATE_ERROR = (state) => {
  state.successRatesLoading = false
  state.successRateError = true
}

export default {
  SR_CONFIGS_LEVEL_UPDATED,
  SR_CONFIGS_LEVEL_LOADING,
  SR_CONFIGS_LEVEL_ERROR,
  SUCCESS_RATE_LOADING,
  SUCCESS_RATE_UPDATED,
  SUCCESS_RATE_ERROR,
  RESET_SUCCESS_RATE,
  SUCCESS_RATE_INITIAL_DATE,
  NO_MORE_SUCCESS_RATE
}
